var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 38,
    viewBox: "0 0 13 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9678 1.42667H3.20354L0.615234 19.1111L3.20354 36.7954H10.9678L8.3795 19.1111L10.9678 1.42667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7394 3.05086H4.23407L1.71359 19.0001L4.23407 34.949H10.7394L8.28392 19.4111V18.5888L10.7394 3.05086ZM3.58585 0H13L9.99751 19.0001L13 38H2.93778L0 19.4111V18.5888L2.93778 0H3.58585Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left-icon.e5ea5bf446f805fe345c7fc190daec2a.svg";
export { ForwardRef as ReactComponent };